/**
 * Curriculum ordering — the single source of truth for the sequence a
 * learner progresses through a course's lessons.
 *
 * Order = ungrouped lessons first, then each module's lessons in module
 * order. Both inputs are assumed already sorted (lessons by their
 * per-module sequence, modules by their sequence); this helper only
 * groups them, reproducing exactly what the learner sees in the sidebar.
 *
 * Extracted so the sidebar and the lesson player can't drift on "what's
 * next" — computing that order two different ways is what let the player
 * declare a mid-course lesson the last one (see also lessonGates.ts,
 * pulled out for the same reason).
 */

interface OrderableLesson {
  id?: number | string | null;
  moduleId?: number | string | null;
}

interface OrderableModule {
  id?: number | string | null;
}

export function orderLessonsByCurriculum<T extends OrderableLesson>(
  lessons: T[],
  modules: OrderableModule[],
): T[] {
  const ungrouped = lessons.filter((l) => l.moduleId == null);
  const grouped = modules.flatMap((m) => lessons.filter((l) => l.moduleId === m.id));
  return [...ungrouped, ...grouped];
}
